// frontend/utils/serverRequest.js
function identityHeaders() {
  const h = {};

  // Token
  const token = localStorage.getItem('token') || '';
  if (token) {
    h['token'] = token;               // mantém compatibilidade com o que você já usa
    if (token.includes('.')) {        // heurística simples p/ JWT
      h['Authorization'] = `Bearer ${token}`;
    }
  }

  // Tenta achar dados do usuário no localStorage (vários padrões comuns no seu projeto)
  let rawUser =
    localStorage.getItem('usuario') ||
    localStorage.getItem('user') ||
    localStorage.getItem('dp_user') ||
    null;

  let u = {};
  try { u = rawUser ? JSON.parse(rawUser) : {}; } catch { u = {}; }

  // Campos possíveis
  const id   = u.id_usuario ?? u.id ?? localStorage.getItem('id_usuario') ?? null;
  const mail = u.ds_usuario ?? u.email ?? localStorage.getItem('ds_usuario') ?? null;
  const nome = u.nome ?? localStorage.getItem('nome') ?? null;

  if (id != null && id !== '')   h['x-dp-user-id'] = String(id);
  if (mail)                      h['x-dp-user']    = String(mail);
  if (nome)                      h['x-dp-user-name'] = String(nome);

  return h;
}

const serverRequest = {
  request: async function (url, body, file) {
    let loader = document.querySelector('.loader');
    try {
      if (loader) loader.classList.remove('invisible');

      const headers = {
        'Content-Type': 'application/json',
        ...identityHeaders()
      };

      let res = await fetch(process.env.REACT_APP_SRV_PATH + url, {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
      });

      if (res.status === 200) {
        if (file) {
          let blob = await res.blob();
          let url = window.URL.createObjectURL(blob);
          return window.location.assign(url);
        } else {
          return await res.json();
        }
      } else if (res.status === 401) {
        window.location.href = '#/login';
        return false;
      } else if (res.status === 403) {
        let msgErro = await res.text();
        alert(`${res.status}: ${msgErro}`);
        window.location.href = '#/';
      } else {
        let msgErro = await res.text();
        alert(`${res.status}: ${msgErro}`);
        return false;
      }
    } catch (err) {
      console.log(err);
      alert('Erro de conexão com o servidor');
      return false;
    } finally {
      if (loader) loader.classList.add('invisible');
    }
  },

  upload: async function (url, form) {
    let loader = document.querySelector('.loader');
    let res;
    try {
      if (loader) loader.classList.remove('invisible');

      const headers = {
        ...identityHeaders()
      };

      try {
        res = await fetch(process.env.REACT_APP_SRV_PATH + url, {
          method: 'POST',
          headers,
          body: form
        });
      } catch (connectionErr) {
        console.error("Falha na conexão:", connectionErr);
        alert("Erro de conexão com o servidor.");
        return false;
      }

      if (!res) {
        alert("Erro: resposta vazia do servidor.");
        return false;
      }

      const contentType = res.headers.get("Content-Type");

      if (res.status === 200) {
        if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
          const blob = await res.blob();
          const filename = getFilenameFromHeaders(res.headers) || "resultado.xlsx";
          return { blob, filename };
        } else {
          return await res.json();
        }
      } else if (res.status === 401) {
        window.location.href = '#/login';
        return false;
      } else {
        let msgErro = await res.text();
        alert(`${res.status}: ${msgErro}`);
        return false;
      }
    } catch (err) {
      console.error("Erro inesperado durante upload:", err);
      alert("Erro inesperado no upload.");
      return false;
    } finally {
      if (loader) loader.classList.add('invisible');
    }
  },

  get: async function (url) {
    let loader = document.querySelector('.loader');
    try {
      if (loader) loader.classList.remove('invisible');

      const headers = {
        ...identityHeaders()
      };

      let res = await fetch(process.env.REACT_APP_SRV_PATH + url, {
        method: 'GET',
        headers
      });

      if (res.status === 200) {
        return await res.json();
      } else if (res.status === 401) {
        window.location.href = '#/login';
        return false;
      } else if (res.status === 403) {
        let msgErro = await res.text();
        alert(`${res.status}: ${msgErro}`);
        window.location.href = '#/';
      } else {
        let msgErro = await res.text();
        alert(`${res.status}: ${msgErro}`);
        return false;
      }
    } catch (err) {
      console.log(err);
      alert('Erro de conexão com o servidor');
      return false;
    } finally {
      if (loader) loader.classList.add('invisible');
    }
  }
};

function getFilenameFromHeaders(headers) {
  const contentDisposition = headers.get('content-disposition');
  if (!contentDisposition) return null;
  const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
  return filenameMatch && filenameMatch[1] ? filenameMatch[1] : null;
}

export default serverRequest;
